import { v4 as uuidv4 } from 'uuid';

import { ADD_TOAST, REMOVE_ALL_TOASTS, REMOVE_TOAST } from '../actions/ToastActions';
import { DEFAULT_TOAST_TYPE, DEFAULT_TOAST_VARIANT } from '../constants/NotificationConstants';
import { getJsonFreeStorageItem } from '../utils/storageUtils';

const toastReducer = (state = [], action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_TOAST: {
      const skipToastNotificationKeys = getJsonFreeStorageItem('skipToastNotificationKeys') || [];
      const toastConfig = payload.toastConfig;
      const { skipToastKey } = toastConfig;

      //we should not add a toast if user marked it not to show again
      if (skipToastNotificationKeys.includes(skipToastKey)) {
        return state;
      }

      const newToast = {
        id: uuidv4(),
        type: DEFAULT_TOAST_TYPE,
        variant: DEFAULT_TOAST_VARIANT,
        ...toastConfig,
      };

      return [...state, newToast];
    }

    case REMOVE_TOAST:
      return state.filter(({ id }) => payload.toastId !== id);

    case REMOVE_ALL_TOASTS: {
      return [];
    }

    default:
      return state;
  }
};

export default toastReducer;
